import { jsx as _jsx } from "react/jsx-runtime";
import { AdapterBuilder, ComponentSync, TS_Tree } from '@nu-art/thunderstorm-frontend/index';
import { calculateConflictResolutionTree } from './tree-calculation.js';
import { ConflictResolutionTreeRenderers } from './tree-rendering.js';
import { ModuleFE_ConflictResolution } from '../../_modules/ModuleFE_ConflictResolution.js';
import './ConflictResolutionTree.scss';
export class ConflictResolutionTree extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.treeAdapter = this.createAdapter(nextProps.dependencies);
        return state;
    }
    createAdapter(dependencies) {
        const tree = calculateConflictResolutionTree(dependencies);
        const conflictResolutionItemMap = ModuleFE_ConflictResolution.getConflictResolutionItemMap();
        return AdapterBuilder()
            .tree()
            .multiRender(ConflictResolutionTreeRenderers(conflictResolutionItemMap))
            .setData(tree)
            .hideRoot()
            .build();
    }
    render() {
        return _jsx(TS_Tree, { adapter: this.state.treeAdapter, className: 'conflict-resolution-tree' });
    }
}
//# sourceMappingURL=ConflictResolutionTree.js.map